import useOnClickOutside from './useOnClickOutside';
import useScrollAreaIntersection from './useScrollAreaIntersection';
import useScrollObserver from './useScrollObserver';

export default {
    useOnClickOutside,
    useScrollAreaIntersection,
    useScrollObserver
};
